<ul class="layout-menu">
	<ng-container *ngFor="let item of menu; let i = index; trackBy: trackByIndex">
		<li app-menuitem [item]="item" [index]="i" [root]="true"></li>
		<!-- <li class="menu-separator"></li> -->
	</ng-container>
</ul>

<!--
	Favorites toasts are keyed and rendered here rather than through the global
	keyless <p-toast> in app.component.html. PrimeNG's <p-messages> subscribes to
	MessageService and accepts any message without a key, so keyless favorites
	messages were also being rendered inline in the search-result message areas
	on pages like User Search and Order Search. A key means only this toast picks
	them up.
-->
<p-toast key="favorites"></p-toast>

<!-- Just a sample for reference, can remove this comment later. First make sure your are not going to use approaches link isAdmin()<nav>
  <ul>
    <li><a routerLink="/dashboard">Dashboard</a></li>
    <li *ngIf="authService.isAdmin()"><a routerLink="/admin">Admin Panel</a></li>
  </ul>
</nav> -->
